<template>
    <div class="downloadContent">
        <!-- 面包屑 -->
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>短剧CPS</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 扫码 -->
        <div class="downloadBox column">
            <el-image :src="require('@/assets/image/download01.png')" fit="cover" class="dlTop"></el-image>
            <div class="dlText">第<span class="dlNum">1</span>步：微信扫描下方二维码，进入微信<span>小程序</span></div>
            <el-image :src="shortCode" fit="cover" class="dlCode"></el-image>
            <div class="dlText">第<span class="dlNum">2</span>步：点击短剧<span>CPS板块</span></div>
            <el-image :src="require('@/assets/image/short01.png')" fit="cover" class="dlImg"></el-image>
            <div class="dlText">第<span class="dlNum">3</span>步：选择一款<span>热门</span>短剧</div>
            <el-image :src="require('@/assets/image/short02.png')" fit="cover" class="dlImg"></el-image>
            <div class="dlText">第<span class="dlNum">4</span>步：生成您的<span>专属</span>推广链接</div>
            <el-image :src="require('@/assets/image/short03.png')" fit="cover" class="dlImg"></el-image>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                shortCode: ''
            }
        },
        mounted(){
            this.getdownload()
        },
        methods: {
           // 获取二维码
           getdownload(){
                this.request.get("index/gongneng/detail",{
                    params:{
                       type: 5
                    }
                })
                .then(res=>{
                    this.shortCode = res.data
                })
            }, 
        }
    }
</script>
<style lang="less" scoped>
    @import '../../common/css/download.less';
</style>